import { Box, Stack, Typography, Button } from '@mui/material';
import { BarChart, PieChart } from '@mui/x-charts';

const noDataChartSetting = {
  height: 140,
  colors: ['#6c6c6c'],
  margin: { left: 0, right: 0, top: 16, bottom: 0 },
  axisHighlight: { y: 'none' as const },
  layout: 'horizontal' as const,
  bottomAxis: null,
  leftAxis: null,
  tooltip: {
    trigger: 'none' as const,
  },
  sx: {
    '& .MuiBarElement-root': {
      height: '12px !important',
    },
  },
};

const ChartPlaceholder: React.FC = () => {
  return (
    <BarChart
      yAxis={[{ scaleType: 'band', data: ['a', 'b', 'c', 'd', 'e', 'f', 'g'], disableTicks: true, disableLine: true, tickLabelStyle: { display: 'none' } }]}
      xAxis={[{ disableTicks: true, disableLine: true, tickLabelStyle: { display: 'none' } }]}
      series={[{ data: [40, 37, 33, 30, 20, 12, 5], type: 'bar' }]}
      slots={{ tooltip: () => null }}
      {...noDataChartSetting}
    />
  );
};

const StackedChartPlaceholder = () => {
  return (
    <BarChart
      height={140}
      colors={['#2F795E', '#7DB25C', '#F6E052', '#FFAC5B', '#FF7F81', '#E46AA8', '#0076FF']}
      series={[
        { data: [4, 2, 4], stack: '1' },
        { data: [5, 4, 3], stack: '1' },
        { data: [3, 3, 2], stack: '1' },
        { data: [3, 3, 3], stack: '1' },
        { data: [1, 1, 2], stack: '1' },
      ]}
      margin={{ left: 0, right: 0, top: 0, bottom: 0 }}
      sx={{
        '& .MuiBarElement-root': {
          filter: 'saturate(0)'
        },
      }}
    />
  );
};

const ReductionCommitmentsPlaceholder: React.FC = () => {
  return (
    <Box sx={{ color: (theme) => theme.palette.divider }}>
      <Typography variant="subtitle2">53 employees</Typography>
      <Typography variant="subtitle2" sx={{ ml: 2 }}>
        150 commitments
      </Typography>
      <Typography variant="subtitle2">12 reduction</Typography>
    </Box>
  );
};

interface SignUpPlaceholderProps {
  invitationLink?: string;
  onCopy: any;
  isCopied: boolean;
  title: string;
  text: string;
}

const NoSignUpsPlaceholder: React.FC<SignUpPlaceholderProps> = ({
  invitationLink,
  onCopy,
  isCopied,
  title,
  text,
}) => {
  return (
    <Stack justifyContent={'space-between'} spacing={2} height={'100%'}>
      <Box
        sx={{ p: 2, backgroundColor: (theme) => theme.palette.branded.paper }}
        textAlign={'center'}
      >
        <Typography variant="h4">{title}</Typography>
      </Box>
      <>
        <Typography variant="body2" textAlign={'center'}>
          {text}
        </Typography>
        {invitationLink && (
        <Button
          onClick={() => invitationLink && onCopy(invitationLink)}
          variant="contained"
          size="small"
          color="ccgrey"
          sx={{ width: 'fit-content', mx: 'auto !important' }}
        >
          {isCopied ? 'Copied!' : 'Copy signup link to clipboard'}
        </Button>
        )}
      </>
    </Stack>
  );
};

const OffsetSubscriptionsPlaceholder: React.FC = () => {
  return (
    <PieChart
      series={[{ data: [{ value: 4 }, { value: 3 }, { value: 1.5 }, { value: 1.5 }] }]}
      {...noDataChartSetting}
      slots={{ tooltip: () => null }}
      colors={['#6c6c6c', '#a4a4a4', '#dedede', '#bebebe']}
    />
  );
};

export {
  ChartPlaceholder,
  ReductionCommitmentsPlaceholder,
  NoSignUpsPlaceholder,
  OffsetSubscriptionsPlaceholder,
  StackedChartPlaceholder,
};
